import { PROJECT_FEED_PAGE, PROJECT_FEED_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const projectUpdateViewRoute = createGlobalRoute({
  exact: true,
  name: PROJECT_FEED_PAGE,
  path: PROJECT_FEED_PATH,
  capabilities: ['projects_app:access'],
  layout: 'home',
  subproduct: 'townsquare-projects',
  enableRestrictedFallback: true,
});
